export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9302.ee09a6bb.jpg";